import React from 'react';

import { useGraphQLQuery } from '@betterment/graphql';
import { Box, Button, Dialog } from '@betterment/samba-react';
import { CardLoader } from '@betterment/shared-components';

import { UnderstandingReturnsDescriptionDocument } from './graphql/understandingReturnsDescription.generated';
import { ReturnDescriptionCard } from './ReturnDescriptionCard';

import { trackClick } from '../../../../../../features/track';

export const UnderstandingReturnsDialog: React.FC<
  React.PropsWithChildren<{ source?: 'cardFooter' | 'columnMenu' }>
> = ({ children, source = 'cardFooter' }) => {
  const { data } = useGraphQLQuery(UnderstandingReturnsDescriptionDocument);
  if (!data) return <CardLoader />;

  const timeWeightedReturnDescription = data.disclosures.timeWeightedReturnExplanation;
  const moneyWeightedReturnDescription = data.disclosures.moneyWeightedReturnExplanation;

  const handleDialogOpen = (open: boolean) => {
    if (open) {
      const trackingName = source === 'columnMenu' ? 'returnsToolTipColumnMenu' : 'returnsToolTip';
      trackClick({
        name: trackingName,
        module: 'Performance',
        location: 'AccountsCard',
      });
    }
  };

  return (
    <Dialog onOpenChange={handleDialogOpen}>
      <Dialog.Trigger asChild={true}>
        <Button
          variant="textPrimary"
          aria-label="Learn more about understanding returns"
          css={{ display: 'flex', alignItems: 'center', gap: 'space.50' }}
        >
          {children}
        </Button>
      </Dialog.Trigger>
      <Dialog.Content
        size="large"
        css={{
          display: 'grid',
          padding: 'space.600',
          overflow: 'auto',
          gap: 'space.300',
        }}
      >
        <Dialog.Title>Understanding your returns</Dialog.Title>
        <Dialog.Description asChild={true}>
          <Box css={{ display: 'grid', gap: 'space.300' }}>
            <ReturnDescriptionCard
              iconName="Trend"
              description={timeWeightedReturnDescription}
              header="Time-weighted return"
            />
            <ReturnDescriptionCard
              iconName="Bar"
              description={moneyWeightedReturnDescription}
              header="Money-weighted return"
            />
          </Box>
        </Dialog.Description>
      </Dialog.Content>
    </Dialog>
  );
};
